'use strict';

var styled = require('styled-components');
var styles = require('../Anchor/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Li = styled__default.default.li `
  display: inline-block;
  color: inherit;
  background: inherit;
  > * {
    overflow: hidden;
    vertical-align: bottom;
    display: inline-block;
    border-radius: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbBorderRadius};
    padding: 0 ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbPaddingX};
  }
  ${styles.Styled.Anchor} {
    color: inherit;
    background: inherit;
    text-decoration: none;
  }
  ${styles.Styled.Anchor} {
    &:hover {
      background: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbHoverBackground};
      color: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbHoverColor};
    }
    &:focus {
      background: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbFocusBackground};
      color: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbFocusColor};
    }
  }
`;
const Ol = styled__default.default.ol `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.designTokens.breadcrumbsFontSize};
  font-family: ${({ theme }) => theme.designTokens.breadcrumbsFontFamily};
  font-weight: ${({ theme }) => theme.designTokens.breadcrumbsFontWeight};
  line-height: ${({ theme }) => theme.designTokens.breadcrumbsLineHeight};
  padding: ${({ theme }) => theme.designTokens.breadcrumbsPaddingY} 0;
  color: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbColor};
  background: ${({ theme }) => theme.designTokens.breadcrumbsBreadcrumbBackground};
`;
const Styled = {
    Ol,
    Li,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
